import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "input"]

  filter() {
    const query = this.inputTarget.value.toLowerCase()

    this.itemTargets.forEach(item => {
      const text = item.dataset.filterValue
      if (this.fuzzyMatch(text, query)) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })
  }

  fuzzyMatch(text, query) {
    if (!query) return true
    
    let i = 0
    let j = 0
    
    while (i < text.length && j < query.length) {
      if (text[i] === query[j]) {
        j++
      }
      i++
    }
    
    return j === query.length
  }
}
